import AppImage from '@theme/components/atom/AppImage'
import AppLink from '@theme/components/atom/AppLink'
import AppTitle from '@theme/components/atom/AppTitle'
import HeadingLevel from '~/mixins/HeadingLevel'

export default {
  mixins: [HeadingLevel],
  components: {
    AppImage,
    AppLink,
    AppTitle,
  },
  props: {
    point: {
      type: Object,
      default: () => [],
    },
  },
  computed: {
    hasIcon() {
      return !!(this.point.icon || (this.point.iconImage && this.point.iconImage.path))
    },
  },
  methods: {
    getLinkComponent() {
      if (this.point.link) {
        return 'AppLink'
      }
      if (this.point.path) {
        return 'nuxt-link'
      }
      return 'div'
    },
    getLinkProps() {
      if (this.point.link) {
        return {
          link: this.point.link,
        }
      }
      if (this.point.path) {
        return {
          to: typeof this.point.path === 'object' ? this.localePath(this.point.path) : this.point.path,
        }
      }
      return {}
    },
  },
}
